import React from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import TokenManager from "./utils/TokenManager";

const UserAccess = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("loginDetails");
  const accessToken = TokenManager.getAccessToken();
  const history = useHistory();

  return (
    <Route
      {...rest}
      render={(props) => {
        // Check both old token format and new token format
        if (token || accessToken) {
          return <Component {...props} />;
        } else {
          // Save the current path to localStorage before redirecting
          localStorage.setItem("redirectAfterLogin", props.location.pathname);

          // Use TokenManager for logout
          TokenManager.handleLogout("Please login to access this page");
          return null;
        }
      }}
    />
  );
};

export default UserAccess;
